import React, { PureComponent } from 'react';
import { lazyGettext } from '@eb/i18n-ebspa';

import CookieNotification from 'eventbrite_design_system/notification/CookieNotification';

import {
    LEGAL_UPDATE_DISMISSED_COOKIE,
    LEGAL_UPDATE_SEEN_COOKIE,
} from '../constants';

import cookies from 'cookies-js';

import { HAS_WINDOW } from '@eb/feature-detection';

/*
 * @return String - current date formatted as yyyy-mm-dd
 */
const _getFormattedDate = () => new Date().toISOString().split('T')[0];

/*
 * Check all the conditions we have to meet in order to decide whether the legal
 * update notification should be displayed or not.
 *
 * The notification should be displayed for two weeks, or until the user dismiss
 * the notification.
 *
 * Also since we are using cookies for this, the notification will not be
 * displayed if the user hasn't agreed our cookies header.
 *
 * @returns {Boolean} true/false
 */
const _shouldShowLegalNotification = () => {
    let showLegalUpdateNotification = false;

    if (HAS_WINDOW) {
        const hasLegalUpdateCookie = cookies.get(LEGAL_UPDATE_DISMISSED_COOKIE);

        const today = _getFormattedDate();
        const legalUpdateFirstSeen = cookies.get(LEGAL_UPDATE_SEEN_COOKIE);
        const timeDiff = new Date(today) - new Date(legalUpdateFirstSeen);
        const days = timeDiff / (1000 * 60 * 60 * 24);
        const isNotificationExpired = days > 14;

        if (!(hasLegalUpdateCookie || isNotificationExpired)) {
            showLegalUpdateNotification = true;
        }
    }

    return showLegalUpdateNotification;
};

/*
 * Sets a cookie with the date the user sees the legal update notification for
 * the first time.
 */
const _setSeenLegalNotificationCookie = () => {
    let hasSeenLegalUpdate;

    if (HAS_WINDOW) {
        hasSeenLegalUpdate = cookies.get(LEGAL_UPDATE_SEEN_COOKIE);

        if (!hasSeenLegalUpdate) {
            const date = _getFormattedDate();

            hasSeenLegalUpdate = cookies.set(LEGAL_UPDATE_SEEN_COOKIE, date);
        }
    }

    return hasSeenLegalUpdate;
};

export default class LegalNotification extends PureComponent {
    componentDidMount() {
        _setSeenLegalNotificationCookie();
    }

    render() {
        let component = null;

        if (_shouldShowLegalNotification()) {
            component = (
                <CookieNotification
                    actionText={null}
                    cookieName={LEGAL_UPDATE_DISMISSED_COOKIE}
                    linkHref="/l/LegalTerms"
                    linkText={lazyGettext(
                        'We invite you to review the updated terms and policies here.',
                    )}
                    message={lazyGettext(
                        "We've changed some of our Legal Terms, including our Terms of Service, Privacy Policy and Merchant Agreement.",
                    )}
                />
            );
        }

        return component;
    }
}
